const FALLBACK_DUMMY_DATA = {
  documentId: 548947,
  fileExtension: 'pdf',
  fileName: 'test.docx',
  fileSize: 2305000,
  readableFileSize: '2.3 MB',
  score: {
    total: 42,
    screeningSoftware: 50,
    hardSkills: 37,
    softSkills: 53,
    persuasion: 29,
  },
  problems: {
    totalCount: 9,
    screeningSoftware: {
      count: 3,
      fileType: false,
      fileSize: false,
      layout: true,
      pictures: false,
      contactDetails: false,
    },
    hardSkills: {
      count: 3,
      missing: 3,
      required: 8,
    },
    softSkills: {
      count: 1,
      missing: 1,
      required: 4,
    },
    persuasion: {
      count: 3,
      spelling: false,
      career: true,
      achievements: true,
      language: false,
      length: false,
      presentation: true,
    },
  },
};

const state = () => ({
  packages: [],
  selectedPackage: '',
  resumeSmartApply: null,
});

const mutations = {
  setPackages(currentState, payload) {
    currentState.packages = payload;
  },
  setSelectedPackage(currentState, payload) {
    currentState.selectedPackage = payload;
  },
  setResumeSmartApply(currentState, payload) {
    currentState.resumeSmartApply = payload;
  },
};
// actions
const actions = {
  setResumeSmartApply({ commit }, payload) {
    commit('setResumeSmartApply', payload?.dummy ? FALLBACK_DUMMY_DATA : payload);
  },
  fetch({ state: currentState, commit, rootGetters }) {
    if (currentState.packages.length) return;
    return this.$api
      .get(rootGetters.getApiLink('user.smartapplyOffers'))
      .then(({ data }) => {
        commit('setPackages', data);
        return data;
      })
      .catch(() => {
        throw new Error('something went wrong');
      });
  },
  setPackage({ commit }, data) {
    commit('setSelectedPackage', data);
  },
};
const getters = {
  packages: (currentState) => currentState.packages,
  selectedPackage: (currentState) => currentState.selectedPackage,
  resumeSmartApply: (s) => s.resumeSmartApply,
};

export default {
  namespaced: true,
  mutations,
  state,
  actions,
  getters,
};
